// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"a80f5673","127":"f338ba72","263":"f338ba72","348":"f338ba72","598":"a80f5673","991":"f338ba72"}[chunkId] + ".chunk.css";
};